import { createAction, props } from '@ngrx/store';

import { SearchListState } from '@store';

import { SearchListType } from './search.model';

export namespace SearchActions {
  export enum Type {
    ADD_TO_LIST_SEARCH = '[SEARCH] Add To List Search',
    LIST_SEARCH = '[SEARCH] List Search',
    LIST_SEARCH_SUCCESS = '[SEARCH] List Search Success',
    LIST_SEARCH_ERROR = '[SEARCH] List Search Error',
  }

  export const AddToListSearch = createAction(
    Type.ADD_TO_LIST_SEARCH,
    props<{
      payload: {
        type: SearchListType;
        searchParams: any;
        timestamp: string;
      };
    }>()
  );

  export const ListSearch = createAction(Type.LIST_SEARCH);

  export const ListSearchSuccess = createAction(
    Type.LIST_SEARCH_SUCCESS,
    props<{ payload: SearchListState }>()
  );

  export const ListSearchError = createAction(Type.LIST_SEARCH_ERROR);
}
